import React from 'react';
import autoBind from 'react-autobind';
import { withRouter } from 'react-router';
import ApplicationLoadingStore from '../stores/ApplicationLoadingStore';
import Transitions from '../core/Transitions';
import Spinner from './Common/Spinner.jsx';
import ApplicationConstants from '../constants/ApplicationConstants';

function getState() {
    return {
        nextView: ApplicationLoadingStore.getNextView()
    };
}

class ApplicationLoading extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getState();
    }

    componentDidMount() {
        ApplicationLoadingStore.addChangeListener(this._onChange);
    }

    componentWillUnmount() {
        ApplicationLoadingStore.removeChangeListener(this._onChange);
    }

    componentWillUpdate(nextProps, nextState) {
        if (nextState.nextView) {
            Transitions.forwardFromApplicationLoading(this.props.router, { nextView: nextState.nextView });
        }
    }

    _onChange() {
        this.setState(getState());
    }

    render() {
        return (
            <div className="start">
                <div className="container">
                    <h2>Loading Application</h2>
                    <Spinner size={ApplicationConstants.SpinnerSizes.Three}/>
                </div>
            </div>
        );
    }
}

export default withRouter(ApplicationLoading)


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/ApplicationLoading.jsx